import { useParentingSpace } from "hooks/useParentingSpace";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Button, Spinner } from "reactstrap";

const InvitedSpaces = () => {
    const { getInvitedParentingSpaces ,joinParentingSpace} = useParentingSpace();
    const [invites, setInvites] = useState([]);
    const [isJoinLoading, setIsJoinLoading] = useState(false);
    // const spaces = 
    //  [
    //     { id: '1', name: 'New Parents Group', invitedBy: 'Jane Doe', logo: '/placeholder.svg?height=40&width=40' },
    //     { id: '2', name: 'Toddler Time', invitedBy: 'John Smith', logo: '/placeholder.svg?height=40&width=40' },
    //     { id: '3', name: 'School-Age Support', invitedBy: 'Alice Johnson', logo: '/placeholder.svg?height=40&width=40' },
    // ];
   
    const fetchInvites = async () => {
          const fetchedInvites = await getInvitedParentingSpaces();
          setInvites(fetchedInvites); // Set the invites state
        
      };
    useEffect(() => {
        fetchInvites(); // Call the fetch function
      }, []); 

    const handleJoinSpace = async (spaceId) => {
        try {
            setIsJoinLoading(true);
            await joinParentingSpace(spaceId); // Call joinParentingSpace with the spaceId
            setIsJoinLoading(false);
            // Optionally, you can show a success message or update the UI

    } catch (error) {
            setIsJoinLoading(false);        
        }
    };
    return (
        <>
        {invites.length > 0 ? (
            <ul className="list-unstyled">
                {invites.map((invite) => (
                    <li key={invite.id} className="d-flex align-items-center justify-content-between bg-light p-3 mb-3 rounded">
                        <div className="d-flex align-items-center">
                            <div className="me-3">
                                <img
                                    src={`https://avatar.iran.liara.run/public/${Math.floor(Math.random() * 100)}`}
                                    alt={`${invite?.parenting_space?.name} logo`}
                                    width={40}
                                    height={40}
                                    className="rounded-circle"
                                />
                            </div>
                            <div>
                                <h5 className="mb-1">{invite?.parenting_space?.name}</h5>
                                <p className="text-muted mb-0">Invited by: {invite?.user?.name}</p>
                            </div>
                        </div>
                        <div>
                        <button onClick={() => handleJoinSpace(invite?.id)} disabled={isJoinLoading}>
                            {isJoinLoading ? (
                                <div className="d-flex align-items-center">
                                   <Spinner  />
                                </div>
                            ) : (
                                "Join Space"
                            )}
                        </button> {/* Join Space button */}
                        </div>
                    </li>
                ))}
            </ul>
        ) : (
            <p>No space invite available</p>
        )}
        </>
    );
};
 

export default React.memo(InvitedSpaces);